<template>
    <div>
        <div class="dx-field">
            <div class="dx-field-label">Головное предприятие</div>
            <div class="dx-field-value">
                <ai-select-box-clearable
                    :value="data.kod_parent"
                    :data-source="list"
                    value-expr="id"
                    display-expr="name"
                />
            </div>
        </div>
    </div>
</template>

<script setup>
import { inject } from 'vue';
import aiSelectBoxClearable from '@/components/ai-select-box-clearable.vue';

const list = [{ id: 1, name: 'ИП КОМИССАРЕНКО ВАЛЕРИЙ ВАЛЕРЬЕВИЧ' }];

const data = inject('serverData');
</script>
